/* HBH Finish Swatches - Image preview on swatch hover
   =====================================================
   When user hovers a swatch (not the current product's), preview
   that finish's image inside the product card without navigating.
   Click still navigates to the sibling product.
   ===================================================== */
(function () {
  'use strict';

  function findCardImage(swatchContainer) {
    // Walk up to the nearest product card, then find its primary image
    var node = swatchContainer;
    for (var i = 0; i < 8 && node; i++) {
      node = node.parentElement;
      if (!node) break;
      if (
        node.matches &&
        (node.matches('.product-grid-item') ||
          node.matches('.product-card-wrapper') ||
          node.matches('.product-card') ||
          node.matches('.product-item') ||
          node.matches('.card') ||
          node.matches('.card__inner'))
      ) {
        return (
          node.querySelector('img.card__media-image') ||
          node.querySelector('.card__media img') ||
          node.querySelector('.product-image img') ||
          node.querySelector('.product-card-media img') ||
          node.querySelector('img')
        );
      }
    }
    return null;
  }

  function attachSwatchHandlers(root) {
    var containers = (root || document).querySelectorAll(
      '.hbh-finish-swatches'
    );
    containers.forEach(function (container) {
      if (container.dataset.hbhBound === '1') return;
      container.dataset.hbhBound = '1';

      var img = findCardImage(container);
      if (!img) return;
      var originalSrc = img.currentSrc || img.src;
      var originalSrcset = img.srcset;

      var swatches = container.querySelectorAll('.hbh-swatch');
      swatches.forEach(function (sw) {
        var newSrc = sw.getAttribute('data-image');
        if (!newSrc) return;

        sw.addEventListener('mouseenter', function () {
          if (sw.classList.contains('hbh-swatch--current')) return;
          img.src = newSrc;
          img.removeAttribute('srcset'); // override responsive srcset
        });

        sw.addEventListener('mouseleave', function () {
          img.src = originalSrc;
          if (originalSrcset) img.setAttribute('srcset', originalSrcset);
        });

        // Make sure click still works even after mouseleave fires
        sw.addEventListener('click', function (e) {
          // Let the <a> default navigation happen, but ensure image stays on
          // the clicked finish during page transition (visual continuity)
          img.src = newSrc;
        });
      });
    });
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachSwatchHandlers(document);
    });
  } else {
    attachSwatchHandlers(document);
  }

  // Re-bind after Shopify section reload or AJAX (e.g., filter change)
  document.addEventListener('shopify:section:load', function () {
    attachSwatchHandlers(document);
  });
  document.addEventListener('shopify:section:reorder', function () {
    attachSwatchHandlers(document);
  });

  // For Horizon's instant-page navigation (view transitions)
  document.addEventListener('page:loaded', function () {
    attachSwatchHandlers(document);
  });

  // Mutation observer for AJAX-loaded collection products
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1) {
          attachSwatchHandlers(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
